import { isNil } from 'lodash';
import { MediaType } from '../../../../../../../Chat.enum';
import { tAttachment } from '../../../../../../../Chat.types';

export function isRenderableAttachment(attachment: tAttachment): boolean {
  const hasUrl = !isNil(attachment.url) && attachment.url !== '';
  const isLocation =
    attachment.mediaType === MediaType.LOCATION &&
    !isNil(attachment.latitude) &&
    !isNil(attachment.longitude);
  const isContact =
    attachment.mediaType === MediaType.CONTACT &&
    !isNil(attachment.vcard) &&
    attachment.vcard !== '';
  // SHARE_POST (TikTok link-preview cards, INT-929) carry no top-level url —
  // SharePostContent renders entirely from the video_id/title/author/thumbnail
  // fields and degrades to a placeholder card when those are empty. Like
  // LOCATION/CONTACT it must be exempt from the hasUrl requirement, or it is
  // dropped before MessageByAttachmentType ever dispatches it.
  const isSharePost = attachment.mediaType === MediaType.SHARE_POST;
  return hasUrl || isLocation || isContact || isSharePost;
}

export function getAttachmentUniqueKey(
  attachment: tAttachment,
  index?: number,
): string {
  if (attachment.mediaType === MediaType.LOCATION && !attachment.url) {
    return `location-${attachment.latitude}-${attachment.longitude}`;
  }
  if (attachment.mediaType === MediaType.CONTACT && !attachment.url) {
    return `contact-${attachment.vcard}`;
  }
  if (attachment.mediaType === MediaType.SHARE_POST && !attachment.url) {
    // video_id is the canonical TikTok identifier; embed_url is the fallback
    // when extraction left video_id empty.
    const contentKey = attachment.video_id || attachment.embed_url;
    if (contentKey) {
      return `share-post-${contentKey}`;
    }
    // Total extraction failure — no content-derived identity. Key by position
    // so two failed-extraction cards in one event stay distinct instead of
    // collapsing to one under the dedup filter.
    return `share-post-pos-${index ?? attachment.mediaType}`;
  }
  return attachment.url || `attachment-${attachment.mediaType}`;
}
